/* eslint-disable react/no-array-index-key */
import {
  Box,
  TableCell,
  TableFooter,
  TableRow,
} from '@mui/material';
import React, { Fragment } from 'react';

import useStyles from './style';

type FooTerType = {
  footerComponents?: any[],
  footerDataSet?: any[]
  disableFullborderCell?:boolean
};

const DEFAULT_FOOTER_COMPONENTS = [];
const DEFAULT_FOOTER_DATA_SET = [];

const FooterTable = ({
  footerComponents = DEFAULT_FOOTER_COMPONENTS,
  footerDataSet = DEFAULT_FOOTER_DATA_SET,
  disableFullborderCell = false
}: FooTerType) => {
  const { borderCellStyle } = useStyles();
  return (
    <TableFooter>
      {footerDataSet && footerDataSet.map((item, index) => (
        <Fragment key={`footer-data-${index}`}>
          {footerComponents && (
          <TableRow>
            {footerComponents?.map((footer, iterator) => (
              <TableCell
                colSpan={footer?.colspan || 0}
                style={{ textAlign: 'center' }}
                key={`footer-component-${iterator}`}
                className={`
                ${!disableFullborderCell && borderCellStyle}
                `}
              >
                <Box>
                  {footer.renderer(item)}
                </Box>
              </TableCell>
            ))}
          </TableRow>
          )}

        </Fragment>
      ))}
    </TableFooter>
  );
};

export default FooterTable;
